import React from "react";
import { fmtCredits, fmtPct, fmtUsd, tone } from "./marginUtil";

export function MarginCards({ t }) {
  const cards = [
    ["net", "Pendapatan bersih", fmtUsd(t?.net_revenue_usd), `bruto ${fmtUsd(t?.revenue_usd)} · PPN ${fmtUsd(t?.tax_usd)}`, ""],
    ["cost", "Biaya AI", fmtUsd(t?.cost_usd), t?.cost_actual_usd != null ? `riil ${fmtUsd(t.cost_actual_usd)} · katalog ${fmtUsd(t.cost_catalog_usd)}` : "biaya provider tanpa margin", ""],
    ["margin", "Margin", fmtUsd(t?.margin_usd), "pendapatan bersih − biaya", tone(t?.margin_usd)],
    ["markup", "Markup", fmtPct(t?.markup_pct), "margin ÷ biaya", tone(t?.markup_pct)],
    ["gross", "Gross margin", fmtPct(t?.gross_margin_pct), "margin ÷ pendapatan bersih", tone(t?.gross_margin_pct)],
    ["credits", "Kredit terpakai", fmtCredits(t?.credits), `${(t?.events ?? 0).toLocaleString("id-ID")} kejadian`, ""],
  ];
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-6" data-testid="margin-cards">
      {cards.map(([k, l, v, h, c]) => (
        <div key={k} className="aivora-card relative overflow-hidden p-5" data-testid={`margin-card-${k}`}>
          {k === "margin" && <span className="absolute inset-x-0 top-0 h-1 bg-[image:var(--brand-grad)]" />}
          <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">{l}</p>
          <p className={`mt-1 font-mono text-2xl font-bold tracking-tight ${c || "text-slate-900"}`} data-testid={`margin-card-${k}-value`}>{t ? v : "…"}</p>
          <p className="mt-0.5 truncate text-[11px] text-slate-400" title={h}>{h}</p>
        </div>
      ))}
    </div>
  );
}
